var __TEMP__ = require('./_createRound.js');var createRound = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */
var floor = createRound('floor');

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = floor;
